import(/* webpackMode: "eager", webpackExports: ["Programs"] */ "/vercel/path0/src/components/sections/programs.tsx");
